/**
 * useTutorResourcesState — l'onglet « Ressources pédagogiques » : la feuille des règles d'or ouverte
 * ou non, et les portes.
 *
 * Port de `tutor/home/tutorResources/TutorResources.js`, dans son ordre : « Les 5 règles d'or » (leur
 * texte, dans l'app, à la place de l'affiche du site), « Formation du tuteur » (`videos-coaching`, sans
 * le coaching), puis deux pages web, mêmes adresses (un onglet sur le web, le navigateur intégré
 * ailleurs). Le référentiel des activités n'est pas porté (décision du 02/11), le fichier des énoncés
 * est retiré (obsolète, 03/11).
 */
import { useNavigation } from "@react-navigation/native"
import { useState } from "react"

import { championSlugsToNames } from "../../../../../../data/constants/championsConstants"
import { TUTOR_CHARTER_URL } from "../../../../adapters/tutor/shared/tutorLinks"
import { openExternalUrl } from "../../../hooks/openExternalUrl"

const BLOG_URL = "https://masteur.com/blog"

type StackNavigation = { push: (route: string, params?: object) => void }

export function useTutorResourcesState() {
    const navigation = useNavigation() as unknown as StackNavigation
    const [goldenRulesVisible, setGoldenRulesVisible] = useState(false)

    return {
        goldenRulesVisible,
        /** Le champion qui prépare l'élève, nommé par les règles d'or. */
        helperName: championSlugsToNames.sam,
        onOpenGoldenRules: () => setGoldenRulesVisible(true),
        onCloseGoldenRules: () => setGoldenRulesVisible(false),
        onOpenTrainingVideos: () => navigation.push("videos-coaching", { coaching: false }),
        onOpenCharter: () => openExternalUrl(TUTOR_CHARTER_URL),
        onOpenBlog: () => openExternalUrl(BLOG_URL),
    }
}
